// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S2wd","badges":"styles_badges__3T-hv"};